import { render, staticRenderFns } from "./LoaderIcon.vue?vue&type=template&id=7ff29868&scoped=true&"
import script from "./LoaderIcon.vue?vue&type=script&lang=js&"
export * from "./LoaderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff29868",
  null
  
)

export default component.exports